module.exports = __webpack_public_path__ + "img/album18_53.16456512.jpg";